import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import Checkbox from '@bibliocommons/base-checkbox';

import './CheckboxField.scss';

class CheckboxField extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleToggleFilter');
  }

  handleToggleFilter(checked, { value: filter }) {
    this.props.handleToggleFilter(this.props.fieldId, filter);
  }

  render () {
    const { fieldId, filter } = this.props;
    const applied = filter.get('applied');
    const checkboxId = [fieldId, applied].join('-');

    return (
      <section className="cp-checkbox-field">
        <Checkbox
          id={checkboxId}
          handleChange={this.handleToggleFilter}
          value={filter}
          checked={applied}
          label={(<FormattedMessage id={`${fieldId}.field`} />)}
          labelTestId={`${checkboxId}-field`} />
      </section>
    );
  }
}

CheckboxField.propTypes = {
  filter: ImmutablePropTypes.map.isRequired,
  fieldId: PropTypes.string.isRequired,
  handleToggleFilter: PropTypes.func.isRequired
};

export default CheckboxField;



// WEBPACK FOOTER //
// ./app/components/shared/Facets/CheckboxField/CheckboxField.jsx